import { useEffect, useCallback, useRef } from 'react'
import useCommand from '../components/useCommand'

// IDs discrets pour les types d'événements (pas de strings explicites)
const EVENT_IDS = {
  SCREENSHOT: 1,
  DEVTOOLS_OPEN: 2,
  DEVTOOLS_SHORTCUT: 3,
  F12: 4
}

const useScreenshotDetection = () => {
  const lastDetection = useRef({})
  const devToolsOpen = useRef(false)
  const DEBOUNCE_MS = 2000

  const { runCommand } = useCommand({
    command: 'POST_ANALYTICS',
    manualRun: true
  })

  const sendEvent = useCallback((eventId) => {
    const now = Date.now()
    if (lastDetection.current[eventId] && now - lastDetection.current[eventId] < DEBOUNCE_MS) {
      return
    }
    lastDetection.current[eventId] = now

    runCommand({
      p: window.location.pathname + window.location.search,
      e: eventId
    })
  }, [runCommand])

  // Détection DevTools via taille de fenêtre
  useEffect(() => {
    const detectDevToolsViaSize = () => {
      const widthThreshold = window.outerWidth - window.innerWidth > 160
      const heightThreshold = window.outerHeight - window.innerHeight > 160
      
      if (widthThreshold || heightThreshold) {
        if (!devToolsOpen.current) {
          devToolsOpen.current = true
          sendEvent(EVENT_IDS.DEVTOOLS_OPEN)
        }
      } else {
        devToolsOpen.current = false
      }
    }

    const devToolsInterval = setInterval(detectDevToolsViaSize, 3000)
    window.addEventListener('resize', detectDevToolsViaSize)

    return () => {
      clearInterval(devToolsInterval)
      window.removeEventListener('resize', detectDevToolsViaSize)
    }
  }, [sendEvent])

  // Détection touches clavier
  useEffect(() => {
    const handleKeyEvent = (event) => {
      const key = event.key
      const code = event.code
      const ctrl = event.ctrlKey
      const shift = event.shiftKey
      const meta = event.metaKey

      // PrintScreen
      if (key === 'PrintScreen' || code === 'PrintScreen') {
        sendEvent(EVENT_IDS.SCREENSHOT)
        return
      }

      // Win+Shift+S (Windows Snipping Tool)
      if (meta && shift && (key === 's' || key === 'S' || code === 'KeyS')) {
        sendEvent(EVENT_IDS.SCREENSHOT)
        return
      }

      // Ctrl+Shift+S
      if (ctrl && shift && (key === 's' || key === 'S' || code === 'KeyS') && !meta) {
        sendEvent(EVENT_IDS.SCREENSHOT)
        return
      }

      // Mac captures
      if (meta && shift && (key === '3' || key === '4' || key === '5' || code === 'Digit3' || code === 'Digit4' || code === 'Digit5')) {
        sendEvent(EVENT_IDS.SCREENSHOT)
        return
      }

      // F12
      if (key === 'F12' || code === 'F12') {
        sendEvent(EVENT_IDS.F12)
        return
      }

      // Ctrl+Shift+I (DevTools)
      if (ctrl && shift && (key === 'i' || key === 'I' || code === 'KeyI')) {
        sendEvent(EVENT_IDS.DEVTOOLS_SHORTCUT)
        return
      }

      // Ctrl+Shift+J (Console)
      if (ctrl && shift && (key === 'j' || key === 'J' || code === 'KeyJ')) {
        sendEvent(EVENT_IDS.DEVTOOLS_SHORTCUT)
        return
      }
    }

    window.addEventListener('keydown', handleKeyEvent, true)
    window.addEventListener('keyup', handleKeyEvent, true)
    
    return () => {
      window.removeEventListener('keydown', handleKeyEvent, true)
      window.removeEventListener('keyup', handleKeyEvent, true)
    }
  }, [sendEvent])
}

export default useScreenshotDetection